import { FETCH_CAPACITY, FETCH_LIVE_CAPACITY, FETCH_CAPACITY_FAIL, FETCH_LIVE_CAPACITY_FAIL } from './types';
import { SLACK_WEBHOOKS  } from '../config';
import axios from 'axios';
import { history } from '../components/app';
import { SlackWebhook } from './utils';



/**
 * Fetch capacity via Busabout API
 *
 * @param {string} tourID - product tour id.
 * @param {string} currency - currency (GBP, AUD, USD, CAD).
 * @param {string} [cityID] - cityID for hoho trips.
 * @param {string} [queryString] - queryString affliate id's.
 */
export function FetchCapacity(tourID, currency, cityID, queryString){

  const hasCityID = (cityID !== "") ? `&city_id=${cityID}` : "";
  const capacityURL = `${process.env.REACT_APP_CAPACITY_API}${tourID}?currency=${currency}${hasCityID}&api_token=${process.env.REACT_APP_API_TOKEN}`;

  return (dispatch) => {
    axios.get(capacityURL, {withCredentials: true})
    .then((data) => {
      dispatch({type:FETCH_CAPACITY, payload:data})
    })
    .catch((err)=>{
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! CAPACITY API - ' + capacityURL + " " + err}));
      dispatch({type:FETCH_CAPACITY_FAIL})
      console.error(err);
      history.push('/500');
    })
  }
}

/**
 * Fetch live capacity via Busabout API
 *
 * @param {string} tourID - product tour id.
 * @param {string} currency - iso currency (GBP, AUD, USD, CAD).
 * @param {string} [cityID] - cityID for hoho trips.
 * @param {number} [year] - tour year.
 * @param {number} [month] -tour month.
 * @param {number} [day] - tour day.
 */
export function FetchLiveCapacity(tourID, currency, cityID, year, month, day){

  const hasYear = (year !== "") ? `/${year}/${month}/${day}` : "";
  const hasCityID = (cityID !== "") ? `&city_id=${cityID}` : "";
  const capacityURL =  `${process.env.REACT_APP_CAPACITY_API}${tourID}${hasYear}/live?currency=${currency}${hasCityID}&api_token=${process.env.REACT_APP_API_TOKEN}`;

  return (dispatch) => {
    axios.get(capacityURL, {withCredentials: true})
    .then((data) => {
      dispatch({type:FETCH_LIVE_CAPACITY, payload:data})
    })
    .catch((err)=>{
      dispatch({type:FETCH_LIVE_CAPACITY_FAIL})
      console.error(err);
      history.push('/500');
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/capacity.js